'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'users';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f0c0';
var svgPathData = ['M8 304l212.1 0c-17.6-21.9-28.1-49.7-28.1-80c0-5.4 .3-10.8 1-16l-89 0c-48.6 0-88 39.4-88 88c0 4.4-3.6 8-8 8zM80 80a64 64 0 1 0 128 0A64 64 0 1 0 80 80zm64 405.3c0 5.9 4.8 10.7 10.7 10.7l330.7 0c5.9 0 10.7-4.8 10.7-10.7C496 420.5 443.5 368 378.7 368l-117.3 0C196.5 368 144 420.5 144 485.3zM240 224a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm179.9 80L632 304c-4.4 0-8-3.6-8-8c0-48.6-39.4-88-88-88l-89 0c.7 5.2 1 10.6 1 16c0 30.3-10.5 58.1-28.1 80zM448 80a64 64 0 1 0 128 0A64 64 0 1 0 448 80z', 'M80 80a64 64 0 1 1 128 0A64 64 0 1 1 80 80zm144 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 48l117.3 0C443.5 368 496 420.5 496 485.3c0 5.9-4.8 10.7-10.7 10.7l-330.7 0c-5.9 0-10.7-4.8-10.7-10.7C144 420.5 196.5 368 261.3 368zm0-16C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0zM512 16a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm24 48c48.6 0 88 39.4 88 88c0 4.4 3.6 8 8 8s8-3.6 8-8c0-57.4-46.6-104-104-104l-92 0c1.3 5.2 2.4 10.6 3 16l89 0zm-343 0c.7-5.4 1.7-10.8 3-16l-92 0C46.6 192 0 238.6 0 296c0 4.4 3.6 8 8 8s8-3.6 8-8c0-48.6 39.4-88 88-88l89 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUsers = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;